import { Embedded } from '@components/embedded/Embedded'
import type { EmbeddedFragment } from '@graphql/fragments/EmbeddedFragment.graphql'
import { useGetEmbedded } from '@graphql/hooks/embedded'
import { suspense } from '@lib/utils/suspense'
import type { FunctionComponent, JSX } from 'react'

/**
 * Renders a standalone iframe section, for youtube videos and such.
 */
export const EmbeddedInternal: FunctionComponent<EmbeddedFragment> = ({
    sys,
    type,
    ...restOfProps
}) => {
    if (restOfProps?.src) {
        return (
            <EmbeddedInternalResolved sys={sys} type={type} {...restOfProps} />
        )
    }

    return <SelfFetchingEmbeddedInternal sys={sys} type={type} />
}

const SelfFetchingEmbeddedInternal: FunctionComponent<EmbeddedFragment> = ({
    sys,
    type,
}) => {
    const { data } = useGetEmbedded({ variables: { id: sys.id } })

    return <EmbeddedInternalResolved sys={sys} type={type} {...data} />
}

const EmbeddedInternalResolved = suspense<
    EmbeddedFragment & JSX.IntrinsicAttributes
>((embedded) => {
    const src = embedded?.src
    if (!src) return null
    return <Embedded {...embedded} src={src} width='100%' />
})

export default EmbeddedInternal
